import { FC, useState } from 'react';
import AccountElement from '@/features/account/components/AccountElement';
import { useTranslation } from 'react-i18next';
import SecurityLockIconSolid from '@/components/icons/SecurityLockIconSolid';
import { Switch } from '@/components/ui/switch';
import ESwitchSecurityModal from '@/components/everridge/ESwitchSecurityModal';
import { ProfileDto } from '@/features/account/types/account-dto.ts';
import { cn } from '@/lib/utils';

type Props = {
	profile?: ProfileDto;
	isMobile?: boolean;
};

const AccountSecurity: FC<Props> = ({ profile, isMobile }) => {
	const [showSecurityModal, setShowSecurityModal] = useState(false);
	const { t } = useTranslation();

	const handleSwitchChange = () => {
		setShowSecurityModal(true);
	};

	const handleCancelModal = () => {
		setShowSecurityModal(false);
	};

	const securityButtons = (
		<div className='flex items-center gap-4'>
			<Switch
				id='two-factor-authentication'
				checked={profile?.twoFactorEnabled}
				onCheckedChange={handleSwitchChange}
			/>
		</div>
	);

	return (
		<div className='p-6 flex flex-col gap-4 border border-popover-100 rounded-2.5xl bg-popover-10 select-none'>
			<h3 className={cn(isMobile && 'text-base')}>
				{t('main.account.security.title')}
			</h3>
			<div className='flex flex-col gap-4'>
				<AccountElement
					label={t('main.account.security.elements.auth.label')}
					value={t('main.account.security.elements.auth.description')}
					icon={SecurityLockIconSolid}
					extensions={securityButtons}
				/>
			</div>
			{showSecurityModal && (
				<ESwitchSecurityModal
					mode={profile?.twoFactorEnabled}
					email={profile?.email}
					onClose={handleCancelModal}
					isMobile={isMobile}
				/>
			)}
		</div>
	);
};

export default AccountSecurity;
